<template>
  <div>
    <iModal
      :title="modelTitle"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="180"
            @submit.native.prevent
          >
            <FormItem label="产品认证（中文）：" prop="name"> 
              <Input v-model="formInline.name" />
            </FormItem>
            <FormItem label="产品认证（英文）：" prop="nameEn"> 
              <Input v-model="formInline.nameEn" />
            </FormItem>
            <FormItem label="是否需要上传认证文件："> 
              <Checkbox v-model="formInline.isNeedFile">是</Checkbox>
            </FormItem>
            <FormItem label="排序：" prop="showIndex">
              <InputNumber :max="99999999" :min="-10" v-model="formInline.showIndex"></InputNumber>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "channel-add",
  props: {
    show: {
      type: Boolean,
      default: false
    }, 
    options:{
      type:Object,
    },
    modelTitle:{
      type:String,
    }
  },
  data() {
    return {
      loading: false,
      showModal: false,
      time: [],
      editId:'',
      formInline: {
        // form双向绑定
        name: "",
        nameEn:'',
        isNeedFile: false,
        showIndex: 0,
      },
      ruleInline: {
        name: [{ required: true, message: "产品认证（中文）不能为空", trigger: "blur" }]
      }
    };
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
    options(val){
      if(val.msg){ // 编辑
        this.formInline.name = val.msg.name;
        this.formInline.nameEn = val.msg.nameEn;
        this.formInline.isNeedFile = val.msg.isNeedFile;
        this.formInline.showIndex = val.msg.showIndex;
        this.editId = val.msg.id
      }
    }
  },
  created() {},
  methods: {
    ...mapActions({
      addBusType:'hostSetModule/addBusType',
      putBusType:'hostSetModule/putBusType',
    }),
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      this.loading = true;
      if(this.options.model){ // 编辑模式
        let req = {
          Id:this.editId,
          SetValues:{
            Name: form.name,
            NameEn:form.nameEn,
            IsNeedFile: form.isNeedFile,
            ShowIndex: form.showIndex,
          } 
        };
        let opt = {
           req:req,
           url:'/api/ProAuth',
        }
        let bool = await this.putBusType(opt).catch(err => {
           this.loading = false;
        });
        if (!bool) {
          this.loading = false;
          this.$Message.error("操作失败，请重新尝试");
        } else {
          this.$emit("finish");
          this.$Message.success("操作成功！");
          this.cancel();
          this.loading = false;
        }
      }else{ // 新增模式
        let req = {
          Name: form.name,
          NameEn:form.nameEn,
          IsNeedFile: form.isNeedFile,
          ShowIndex: form.showIndex,
        };
        let opt = {
           req:req,
           url:'/api/ProAuth',
        }
        let bool = await this.addBusType(opt).catch(err => {
           this.loading = false;
        });
        if (!bool) {
          this.loading = false;
          this.$Message.error("操作失败，请重新尝试");
        } else {
          this.$emit("finish");
          this.$Message.success("操作成功！");
          this.cancel();
          this.loading = false;
        }
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.$emit("close");
      this.editId = '';
      this.formInline.isNeedFile = false;
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

